import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { AddressService } from "../../services/address.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { CepModel } from "../../../shared/service/cep/model/cep.model";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { TrackInfo } from "../../../shared/service/journey/tracks/model/track-info";
import { CepFactoryService } from "../../../shared/service/cep/cep-factory-service";
import { DataOrigin } from "../../../shared/model/DataOrigin";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { platform } from "@ids/tools";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";

@Component({
  selector: "app-cep",
  templateUrl: "./cep.page.html",
  styleUrls: ["./cep.page.scss"],
})
export class CepPageComponent extends DefaultPageComponent implements OnInit {
  public numberCep = "";
  public idComponentCep = "addressCep";
  placeholder = "00000-000";
  error = false;
  verifyMsgError = false;
  buttonEnable = false;
  textError = "CEP inválido";
  idLabel = "address-cep";
  label = "cep";
  headerId = "cep";
  address: CepModel;
  oldData: any;
  titlePage = "Endereço";
  startStage = "";
  endStage = "";
  dataOrigin = DataOrigin.Mobile;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  showError = false;
  idLabelCep = "idLabelCep";
  idButtonCep = "idButtonCep";
  idVoxelAlertCep = "idVoxelAlertCep";
  addressCepForm = this.formBuilder.group({
    addressCep: this.formBuilder.control("", [
      Validators.required,
      FormValidations.checkShortName,
      FormValidations.validationsName,
    ]),
  });

  constructor(
    private formBuilder: FormBuilder,
    public router: NavController,
    public backNativeService: BackNativeService,
    private addressService: AddressService,
    private title: Title,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private cepFactoryService: CepFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    const dataOriginTrack = this.journeyService.getCurrentTrack(this.headerId)
      ?.parameters?.dataOrigin;
    this.dataOrigin = dataOriginTrack ? dataOriginTrack : this.dataOrigin;

    this.getTrack();
    this.editFieldInvest("cep", "postalCode", "address");
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "address";

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();

    if (this.addressService.dataPersistence === undefined) {
      this.oldData = { ...this.journeyService.registratioJourney.data.address };
      this.addressService.dataPersistence = { ...this.oldData };
    }
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.cep;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathCep,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  verifyCep() {
    const cepValueForm = this.addressCepForm.controls.addressCep.value;
    const cepValue = cepValueForm.replace("-", "").replace(/[^a-z\d]+/gi, "");

    if (cepValue.length === 8) {
      if (
        this.journeyService.journey === TrackTypes.BASIC ||
        this.journeyService.journey === TrackTypes.BASIC_ADDRESS
      ) {
        this.validateBasicCep(cepValue);
      } else {
        this.validateCep(cepValue);
      }
    } else {
      this.buttonEnable = false;
    }
  }

  validateBasicCep(cepValue: string) {
    this.buttonEnable = false;
    this.error = false;
    this.verifyMsgError = false;

    this.cepFactoryService
      .getService(this.dataOrigin)
      .getCep(cepValue)
      .then((data) => {
        this.address = data;
        this.error = false;
        this.verifyMsgError = false;

        this.addressService.addressInitalPostCode = this.address;
        this.buttonEnable = true;
      });
  }

  validateCep(cepValue: string) {
    this.buttonEnable = false;
    this.verifyMsgError = false;

    this.cepFactoryService
      .getService(this.dataOrigin)
      .getCep(cepValue)
      .then(
        (data) => {
          if (data === undefined) {
            this.showError = true;
            setTimeout(() => {
              this.setFocusAlert();
              this.analyticsEventErrorAPI();
            }, 1000);
          } else if (data?.cepNotFound || data?.invalid) {
            this.error = true;
            this.textError = data?.cepNotFound ? "CEP não encontrado" : "CEP inválido";

            setTimeout(() => (this.edit = true), 600);
          } else {

            this.address = data;
            this.error = false;
            this.verifyMsgError = false;
            this.addressService.addressInitalPostCode = this.address;
            this.buttonEnable = true;
          }
        },
        () => {
          this.showError = true;
          setTimeout(() => {
            this.setFocusAlert();
            this.analyticsEventErrorAPI();
          }, 1000);
        }
      );
  }

  resetAlertHandle($event: string) {
    if ($event.length <= 8 && this.showError) {
      this.showError = false;
    }
  }

  registrationData(address: CepModel) {
    this.journeyService.registratioJourney.data.address.street = address?.street
      ? `${address?.street_type} ${address?.street}`
      : undefined;
    this.journeyService.registratioJourney.data.address.state = address?.state
      ? address?.state
      : undefined;
    this.journeyService.registratioJourney.data.address.city = address?.city
      ? address?.city
      : undefined;
    this.journeyService.registratioJourney.data.address.district =
      address?.district ? address?.district : undefined;
    this.journeyService.registratioJourney.data.address.stateName = undefined;
    this.journeyService.registratioJourney.data.address.cityName = undefined;
  }

  clickNext() {
    if (
      this.journeyService.journey === TrackTypes.BASIC ||
      this.journeyService.journey === TrackTypes.BASIC_ADDRESS
    ) {
      this.addressService.setAddressPostalCode(this.numberCep);
      this.registrationData(this.address);
      if (this.addressService.addressInitalPostCode?.street) {
        this.router.navigateForward(["address", "number"]);
      } else {
        this.nextPage();
      }
    } else {
      this.nextPage();
    }
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.cep,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }
  analyticsEventErrorAPI() {
    const it_eventcategory = "Erro";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.errorAPI,
      it_pagename: this.analyticsPage.cep,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  backPage() {
    this.analyticsEventClique();
    const track = this.journeyService.selectedTrack;
    const id =
      this.journeyService.registratioJourney.data.maritalStatus?.maritalStatus;
    const idConjuge = ["608", "612"];
    const filterId = idConjuge.find((x) => x === id);
    const hasStepMaritalStatus =
      track.track.findIndex(
        (page: TrackInfo) => page.pageId === "marital-status"
      ) > -1;

    this.journeyService.registratioJourney.data.address =
      this.addressService.dataPersistence;
    this.addressService.dataPersistence = undefined;

    if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        filterId &&
        hasStepMaritalStatus) ||
      (this.journeyService.journey === TrackTypes.BASIC_V2 &&
        filterId &&
        hasStepMaritalStatus)
    ) {
      this.router.navigateBack(["marital-status", "spouse"]);
    } else if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        !filterId &&
        hasStepMaritalStatus) ||
      (this.journeyService.journey === TrackTypes.BASIC_V2 &&
        !filterId &&
        hasStepMaritalStatus)
    ) {
      this.router.navigateBack(["marital-status", "marital-status"]);
    } else {
      if (
        this.journeyService.journey === TrackTypes.BASIC_ADDRESS_V2 ||
        this.journeyService.journey === TrackTypes.UPDATE_ADDRESS
      ) {
        this.router.navigateForward(["data", "client-data"]);
      } else {
        this.back();
      }
    }
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.address.postalCode) {
      this.numberCep =
        this.numberCep !== ""
          ? this.numberCep
          : this.journeyService.registratioJourney.data.address.postalCode;
      this.addressCepForm.controls.addressCep.setValue(
        this.numberCep !== ""
          ? this.numberCep
          : this.journeyService.registratioJourney.data.address.postalCode
      );
    }
    this.verifyCep();
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  alertLog() {
    this.showError = false;
    this.headerFocus();
  }

  setFocusAlert() {
    const elementFocus = document.querySelector(
      ".ids-alert__title"
    ) as HTMLButtonElement;

    if (platform.os === "IOS") {
      document.body.setAttribute("aria-hidden", "true");

      setTimeout(() => {
        document.body.removeAttribute("aria-hidden");
        setTimeout(() => {
          if (elementFocus) {
            elementFocus.blur();
            elementFocus.focus();
          }
        }, 100);
      }, 400);
    } else {
      elementFocus.focus();
    }
  }
}
